module.exports = __webpack_public_path__ + "img/undertakingCases12.45363acc.jpg";